import React from 'react';
import { Heading, classNames } from '../atoms';
import Flex from '../molecules/Flex';

export interface PageHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  actions?: React.ReactNode;
  justify?: 'between' | 'start';
  title?: React.ReactNode;
  titleClassName?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  actions,
  justify = 'between',
  title,
  titleClassName,
  className,
  children,
  ...props
}) => (
  <Flex
    align="center"
    gap={2}
    justify={justify}
    wrap
    className={classNames('mb-3', className)}
    {...props}
  >
    {title ? <Heading as="h2" className={classNames('mb-0', titleClassName)}>{title}</Heading> : children}
    {actions}
  </Flex>
);

export default PageHeader;
